import { Component, ReactNode } from "react"

import { NAMES_PATTERN } from '../../libs/validation/stringRegex'
import { namesValidation } from "../../libs/validation/remoteValidationAbstract"

import BuildingData from "../../components/building/BuildingData"

import Input from '../../libs/ui/inputs/Input'
import Select from '../../libs/ui/inputs/Select'

import { BaseEnumType } from "../../libs/initialization/remoteInits"

interface HomeStepTwooProps {
    superfice: number | undefined
    uso: string | undefined
    tipo: string | undefined
    piani: number | undefined
    piano: number | undefined

    annoCostruzione: string | undefined
    isRistrutturato: boolean | undefined
    annoRistrutturazione: number | undefined

    indirizzo: string | undefined
    street: string | undefined
    street_number: string | undefined
    zip: string | undefined
    city: string | undefined

    is_manual_address?: boolean
    updateManualSelectionCallBack?: Function

    materiale: string | undefined
    altroMateriale: string | undefined
    stato_abitazione: string | undefined

    anni: any
    materiali: any
    utilizzi: any
    tipologie: any
    stati: any

    superficeError: string | undefined
    usoError: string | undefined
    tipoError: string | undefined
    pianiError: string | undefined
    pianoError: string | undefined

    annoCostruzioneError: string | undefined
    isRistrutturatoError: string | undefined
    annoRistrutturazioneError: string | undefined
    
    indirizzoError: string | undefined
    streetError: string | undefined
    street_numberError: string | undefined
    zipError: string | undefined
    cityError: string | undefined

    materialeError: string | undefined
    altroMaterialeError: string | undefined
    stato_abitazioneError: string | undefined

    updateSuperficeCallBack: Function
    updateUsoCallBack: Function
    updateTipoCallBack: Function
    updatePianiCallBack: Function
    updatePianoCallBack: Function

    updateAnnoCostruzioneCallBack: Function
    updateIsRistrutturatoCallBack: Function
    updateAnnoRistrutturazioneCallBack: Function
    annoRistrutturazioneValidationCallback: Function

    updateAllCallBack: Function
    updateStreetCallBack: Function
    updateNumberCallBack: Function
    updateZipCallBack: Function
    updateCityCallBack: Function

    updateMaterialeCallBack: Function
    updateAltroMaterialeCallBack: Function
    updateStatoAbitazioneCallBack: Function

    expiredSessionCallbak: Function
}

interface State {
    is_manual_address: boolean
}

class HomeStepTwoo extends Component<HomeStepTwooProps, State> {

    constructor (props: any) {
        super (props)

        this.state = {
            is_manual_address: (this.props.is_manual_address !== undefined) ? this.props.is_manual_address : false
        }
    }

    componentDidUpdate(prevProps: Readonly<HomeStepTwooProps>, prevState: Readonly<State>, snapshot?: any): void {
        if (
            this.props.is_manual_address !== undefined &&
            this.props.is_manual_address !== prevProps.is_manual_address &&
            this.props.is_manual_address !== this.state.is_manual_address &&
            this.props.is_manual_address !== prevState.is_manual_address
        ) {
            this.setState({
                is_manual_address: this.props.is_manual_address
            })
        }
    }

    render (): ReactNode {
        const lista_stati_costruzione = (this.props.annoCostruzione === 'dopo2020' && !this.props.isRistrutturato)
            ? this.props.stati
            : (this.props.stati ?? []).filter (
                    (c: BaseEnumType) => c.id !== 'in_costruzione'
                )

        return (
            <>
                <div className="col-12">
                    <BuildingData 
                        superfice={this.props.superfice}
                        uso={this.props.uso}
                        tipo={this.props.tipo}
                        piani={this.props.piani}
                        piano={this.props.piano}

                        annoCostruzione={this.props.annoCostruzione}
                        isRistrutturato={this.props.isRistrutturato}
                        annoRistrutturazione={this.props.annoRistrutturazione}
                        annoRistrutturazioneValidationCallback={this.props.annoRistrutturazioneValidationCallback}

                        indirizzo={this.props.indirizzo}
                        street={this.props.street}
                        street_number={this.props.street_number}
                        zip={this.props.zip}
                        city={this.props.city}

                        anni={this.props.anni}
                        utilizzi={this.props.utilizzi}
                        tipologie={this.props.tipologie}

                        superficeError={this.props.superficeError}
                        usoError={this.props.usoError}
                        tipoError={this.props.tipoError}
                        pianiError={this.props.pianiError}
                        pianoError={this.props.pianoError}
                        annoCostruzioneError={this.props.annoCostruzioneError}
                        isRistrutturatoError={this.props.isRistrutturatoError}
                        
                        indirizzoError={this.props.indirizzoError}
                        streetError={this.props.streetError}
                        street_numberError={this.props.street_numberError}
                        zipError={this.props.zipError}
                        cityError={this.props.cityError}

                        is_manual_address={this.state.is_manual_address}
                        updateManualSelectionCallBack={this.props.updateManualSelectionCallBack}

                        updateSuperficeCallBack={this.props.updateSuperficeCallBack}
                        updateUsoCallBack={this.props.updateUsoCallBack}
                        updateTipoCallBack={this.props.updateTipoCallBack}
                        updatePianiCallBack={this.props.updatePianiCallBack}
                        updatePianoCallBack={this.props.updatePianoCallBack}

                        updateAnnoCostruzioneCallBack={this.props.updateAnnoCostruzioneCallBack}
                        updateAnnoRistrutturazione={this.props.updateAnnoRistrutturazioneCallBack}
                        updateIsRistrutturato={this.props.updateIsRistrutturatoCallBack}
                        
                        updateAll={this.props.updateAllCallBack}
                        updateStreet={this.props.updateStreetCallBack}
                        updateNumber={this.props.updateNumberCallBack}
                        updateZip={this.props.updateZipCallBack}
                        updateCity={this.props.updateCityCallBack}

                        expiredSessionCallbak={this.props.expiredSessionCallbak}
                    />

                    <Select
                        id='materiale' name='materiale'
                        label='Materiali di costruzione' 
                        value={this.props.materiale}
                        options={this.props.materiali}
                        callback={this.props.updateMaterialeCallBack}
                        error={this.props.materialeError}
                    />

                    { this.props.materiale === 'altro' &&
                        <Input 
                            id='altroMateriale' name='altroMateriale' key={'altroMateriale'}
                            label='Altri materiali di costruzione' 
                            value={this.props.altroMateriale}
                            type='text'
                            maxLength={100}
                            callback={this.props.updateAltroMaterialeCallBack}
                            regexp={NAMES_PATTERN}
                            errorDisplayMsg='Valore non valido'
                            remoteValidation={namesValidation}
                            error={this.props.altroMaterialeError}
                        />
                    }

                    <Select
                        id='stato_abitazione' name='stato_abitazione'
                        label="Stato dell'immobile"
                        value={this.props.stato_abitazione}
                        options={lista_stati_costruzione}
                        callback={this.props.updateStatoAbitazioneCallBack}
                        error={this.props.stato_abitazioneError}
                    />
                </div>
            </>
        )
    }
    
}

export default HomeStepTwoo